import {
  formatDateOnlyTime,
  formatTextDate,
  isToday,
  isYesterday,
} from '@witmetrics/utils/time';
import type {
  DateFormat,
  TimeFormat,
  UndecoratedFormAnswer,
} from '@witmetrics/utils';
import type { Answers } from '@/providers/FormProvider';

export const classes = {
  auroraRow:
    'mx-0 mb-[11px] w-full items-center rounded-2xl border border-solid border-black/10 bg-white/[0.82] px-4 py-3 shadow-aurora-card transition-[box-shadow,border-color] hover:border-brand-accent/55 hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  titleWrapper: 'place-between gap-3',
  title:
    'text-[13.5px] font-semibold text-taupe-3 mr-3 hover:underline cursor-pointer outline-none dark:text-mauve-1',
  date: 'text-[12px] text-taupe-1 text-right shrink-0 ml-4 dark:text-mauve-3',
  description: 'text-[11.5px] text-taupe-1 dark:text-mauve-3',
  preview:
    'size-10 rounded-[10px] border-0 bg-black/[0.04] dark:bg-white/[0.06]',
};

export function toAnswersRecord(
  answers: UndecoratedFormAnswer[] | undefined
): Answers {
  return (answers || []).reduce(
    (acc, a) => ({ ...acc, [a.formFieldId]: a.value }),
    {} as Answers
  );
}

export function getUpdatedAtString(
  updatedAt: string,
  dateFormat?: DateFormat,
  timeFormat?: TimeFormat
) {
  if (isToday(updatedAt)) {
    return formatDateOnlyTime(updatedAt, timeFormat);
  } else if (isYesterday(updatedAt)) {
    return `Yesterday, ${formatDateOnlyTime(updatedAt, timeFormat)}`;
  } else if (dateFormat) {
    return formatTextDate(updatedAt, dateFormat);
  } else {
    return formatTextDate(updatedAt);
  }
}
